export default "__VITE_ASSET__dlNCuFqv__"